/* eslint-disable react/require-default-props */
import React from 'react';
import {Platform, View} from 'react-native';
import {noop} from 'lodash';

import {nullComponentDefault} from '/util/defaultProps.util';

import {styles} from './ReportDataProvider.style';
interface ReportDataProviderProps {
  reportData?: any;
  allReportData?: any;
  filtersData?: any;
  reportIsLoading?: boolean;
  reportMeta?: any;
  reportName?: string;
  tierName?: string;
  newReportName?: string;
  reportParams?: any[];
  dataRenderer?: React.ElementType<any>;
  dataRendererProps?: Record<string, any>;
  loadingComponent?: React.ComponentType<any> | null;
  loadingData?: Record<string, any>;
  currentScreenName?: string;
  hideAvatar?: boolean;
  viewTeamData?: () => void;
  loadMore?: Record<string, any>;
  viewTeamsReportCountAllOrg?: number | null;
  viewTeamsReportFilterCount?: number | null;
  watchlistCount?: number | null;
  isFocused?: boolean;
}
class ReportDataProvider extends React.PureComponent<ReportDataProviderProps> {
  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {
      loadingComponent = null,
      loadingData = {},
      reportData = null,
      reportIsLoading = true,
      reportParams = [],
      newReportName = '',
      reportMeta = null,
      reportName = '',
      viewTeamData = noop,
      hideAvatar = false,
      tierName = '',
      dataRenderer: DataRenderer = nullComponentDefault,
      dataRendererProps = {},
      currentScreenName = '',
      allReportData = null,
      loadMore = {},
      viewTeamsReportCountAllOrg = null,
      viewTeamsReportFilterCount = null,
      watchlistCount = null,
      isFocused,
    } = this.props;

    const {listHeaderComponent: ListHeaderComponent = nullComponentDefault} =
      dataRendererProps;

    const content = (
      <>
        <ListHeaderComponent
          loadingData={loadingData}
          reportIsLoading={reportIsLoading}
          reportData={reportData}
          reportMeta={reportMeta}
          reportName={reportName}
          tierName={tierName}
          watchlistCount={watchlistCount}
          viewTeamsReportFilterCount={viewTeamsReportFilterCount}
          viewTeamsReportCountAllOrg={viewTeamsReportCountAllOrg}
        />
        <DataRenderer
          {...dataRendererProps}
          hideAvatar={hideAvatar}
          reportName={reportName}
          reportParams={reportParams}
          newReportName={newReportName}
          loadingComponent={loadingComponent}
          loadingData={loadingData}
          parentScreenName={currentScreenName}
          viewTeamData={viewTeamData}
          allReportData={allReportData}
          loadMore={loadMore}
          isFocused={isFocused}
        />
      </>
    );

    return Platform.OS === 'web' ? (
      <View style={styles.headerContainer}>
        <View style={styles.dataContainer}>{content}</View>
      </View>
    ) : (
      content
    );
  }
}

export default ReportDataProvider;
